/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReplaceCatEventPayloadDto
 */
export interface ReplaceCatEventPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof ReplaceCatEventPayloadDto
     */
    eventName?: string;
    /**
     * 
     * @type {Date}
     * @memberof ReplaceCatEventPayloadDto
     */
    fromDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ReplaceCatEventPayloadDto
     */
    toDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof ReplaceCatEventPayloadDto
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplaceCatEventPayloadDto
     */
    description?: string;
}

/**
 * Check if a given object implements the ReplaceCatEventPayloadDto interface.
 */
export function instanceOfReplaceCatEventPayloadDto(value: object): value is ReplaceCatEventPayloadDto {
    return true;
}

export function ReplaceCatEventPayloadDtoFromJSON(json: any): ReplaceCatEventPayloadDto {
    return ReplaceCatEventPayloadDtoFromJSONTyped(json, false);
}

export function ReplaceCatEventPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReplaceCatEventPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'eventName': json['eventName'] == null ? undefined : json['eventName'],
        'fromDate': json['fromDate'] == null ? undefined : (new Date(json['fromDate'])),
        'toDate': json['toDate'] == null ? undefined : (new Date(json['toDate'])),
        'country': json['country'] == null ? undefined : json['country'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function ReplaceCatEventPayloadDtoToJSON(json: any): ReplaceCatEventPayloadDto {
    return ReplaceCatEventPayloadDtoToJSONTyped(json, false);
}

export function ReplaceCatEventPayloadDtoToJSONTyped(value?: ReplaceCatEventPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eventName': value['eventName'],
        'fromDate': value['fromDate'] == null ? undefined : ((value['fromDate']).toISOString()),
        'toDate': value['toDate'] == null ? undefined : ((value['toDate']).toISOString()),
        'country': value['country'],
        'description': value['description'],
    };
}

